import Vue from "vue";

const jumpPath = {
    help: "/api/redirect/help",
    core: "/api/redirect/core",
    custom: "/api/redirect/custom"
};

Vue.prototype.$jumpPage = function (operationItem = {}, query = {}, path = []) {
    let href = jumpPath[operationItem.routeName || operationItem.name];

    if (href) {
        // 拼接path
        if (path.length) {
            href += "/" + path.join("/");
        }

        // 拼接query
        let defaultQuery = {
            path: "/ssoLoginRedirect",
            ...query
        };
        if (Object.keys(defaultQuery).length) {
            href += "?" + Object.keys(defaultQuery)
                .map(attr => `${attr}=${defaultQuery[attr]}`)
                .join("&");
        }

        // 返回数据格式数据格式
        if (operationItem.callUrl) {
            return href;
        } else if (operationItem.newWindow) {
            window.open(href);
        } else {
            location.href = href;
        }

    } else {
        alert("没有配置基础路径");
    }
};



// WEBPACK FOOTER //
// ./src/global/jumpPage.js